import URLSearchParams from '@ungap/url-search-params';
import { graphql } from 'gatsby';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';

import PageSection from '../components/Common/PageSection';
import RichTextConverter from '../components/Common/RichText/RichTextConverter';
import AgendaHeading from '../components/Generic/AgendaHeading';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import * as styles from './sparkRegister.module.css';

const utms = [
  'custom_field_utm_source',
  'custom_field_utm_campaign',
  'custom_field_utm_offer',
  'custom_field_utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_offer',
  'utm_medium',
];

const SparkRegister = ({ data, location }) => {
  /*console.log(data);*/
  const { page } = data;
  const copySection = page.pageSections[0];
  useEffect(() => {
    const script = document.createElement('script');
    let utmData = '';
    var urlParams = new URLSearchParams(window.location.search);
    let hasParams = false;
    for (let key of urlParams.keys()) {
      if (utms.indexOf(key) > -1 && urlParams[key]) {
        hasParams = true;
        utmData += `&${key}=${urlParams[key]}`;
      }
    }

    if (!hasParams) {
      utms.forEach((utm) => {
        const cookie = Cookies.get(utm);
        if (cookie) {
          urlParams.append(utm, cookie);
          utmData += `&${utm}=${cookie}`;
        }
      });
      //window.history.pushState({}, '', document.location.pathname + '?' + urlParams.toString());
    }

    script.src = `https://www.bigmarker.com/widget/register_widget.js?club=fullstory2&conference=a933412ccc23&widget_type=button_register&series_register=series_register&upcoming_sub_title=Fullstory&live_sub_title=&rec_sub_title=&upcoming_button_text=Register%20Now&live_button_text=Login%20to%20Access%20Spark&rec_button_text=See%20You%20Next%20Year&link_to_channel=false&widget_width=500&widget_height=600&enable_iframe=true&background_color=ffffff&btext_color=2d374d&link_color=1089f5&ltext_color=ffffff&redirect_to_confirmation_page=1&widget_button_registered_content=You’re all set! We look forward to seeing you at Spark! &widget_webinar_descriptions=&widget_redirect_type=redirect&cid=b76a134a2ad1${utmData}`;

    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Layout isSpark pageMeta={data.page.pageMetaData}>
      <MarketingSeo meta={data.page.pageMetaData} slug={location.pathname} />
      <AgendaHeading page={data.page} className={styles.heading} ctaClassName={styles.ctas}></AgendaHeading>

      <PageSection slim>
        <div className={styles.copyGrid}>
          <div className={styles.copy}>
            <RichTextConverter copy={copySection.copy} />
          </div>
          <div className={styles.embed}>
            <div id={'tickets'} />
            <div id="bigmarker-conference-widget-containera933412ccc23"></div>
          </div>
        </div>
      </PageSection>
    </Layout>
  );
};

export default SparkRegister;

export const query = graphql`
  query SparkRegisterQuery($slug: String!) {
    page: contentfulMultipurposePageTemplate(slug: { eq: $slug }) {
      ...MultipurposePage
    }
  }
`;
